import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./addClass.css";

export default function AddClass() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) { setMessage({ text: "Please enter a class name", type: "error" }); return; }
    setLoading(true);
    try {
      await API.post("/school-admin/classes/add/", { name }, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setMessage({ text: "Class added successfully!", type: "success" });
      setName("");
      setTimeout(() => navigate("/school-admin/classes"), 900);
    } catch {
      setMessage({ text: "Error adding class. Please try again.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ac-page">
        <div className="ac-card">

          {/* HEADER */}
          <div className="ac-card-header">
            <span className="ac-card-icon">🏛️</span>
            <div>
              <h2 className="ac-card-title">Add New Class</h2>
              <p className="ac-card-sub">Create a class for your school (e.g. Class 1, Grade 5)</p>
            </div>
          </div>

          {/* ALERT */}
          {message.text && (
            <div className={`ac-alert ac-alert-${message.type}`}>{message.text}</div>
          )}

          {/* FORM */}
          <div className="ac-form-group">
            <label className="ac-label">Class Name</label>
            <input
              type="text"
              className="ac-input"
              placeholder="e.g. Class 1, Grade 5, Standard 10"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              autoFocus
            />
          </div>

          <div className="ac-btn-row">
            <button className="ac-btn-back" onClick={() => navigate("/school-admin/classes")}>
              ← Back
            </button>
            <button className="ac-btn-submit" onClick={handleSubmit} disabled={loading}>
              {loading ? "Adding…" : "+ Add Class"}
            </button>
          </div>

        </div>
      </div>
  );
}
